{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mfrs_2022-12-31/ssmt-fs-mfrs_2022-12-31_role-730000",
  "sheetId": "NotesListOfNotes",
  "label": "[730000] Notes - List of Notes",
  "description": "Comprehensive list of all notes to the financial statements (MFRS - 138 note disclosures)",
  "controls": [
    {
      "qname": "ifrs-full:DisclosureOfAccruedExpensesAndOtherLiabilitiesExplanatory",
      "label": "Disclosure of accrued expenses and other liabilities",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfAcquisitionsAndDisposalsExplanatory",
      "label": "Disclosure of acquisitions and disposals",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfAllowanceForCreditLossesExplanatory",
      "label": "Disclosure of allowance for credit losses",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfAmendmentsToMFRSandPronouncementsIssuedByMASBExplanatory",
      "label": "Disclosure of amendments to MFRS and pronouncements issued by MASB",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfAuditorsRemunerationExplanatory",
      "label": "Disclosure of auditors' remuneration",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfAuthorisationOfFinancialStatementsExplanatory",
      "label": "Disclosure of authorisation of financial statements",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfBasisOfPreparationOfFinancialStatementsExplanatory",
      "label": "Disclosure of basis of preparation of financial statements",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfBiologicalAssetsAndGovernmentGrantsForAgriculturalActivityExplanatory",
      "label": "Disclosure of biological assets",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfBondsExplanatory",
      "label": "Disclosure of bonds",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfBorrowingsExplanatory",
      "label": "Disclosure of borrowings",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfBusinessCombinationsExplanatory",
      "label": "Disclosure of business combinations",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfCapitalCommitmentsExplanatory",
      "label": "Disclosure of capital and other commitments",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfCapitalRiskManagementExplanatory",
      "label": "Disclosure of capital management",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfCashAndBankBalancesAtCentralBanksExplanatory",
      "label": "Disclosure of cash and bank balances at central banks",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfCashAndCashEquivalentsExplanatory",
      "label": "Disclosure of cash and cash equivalents",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfCashFlowStatementExplanatory",
      "label": "Disclosure of cash flow reconciliation",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfCashHeldUnderHousingDevelopmentAccountsExplanatory",
      "label": "Disclosure of cash held under housing development accounts",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfChangesInAccountingPoliciesAccountingEstimatesAndErrorsExplanatory",
      "label": "Disclosure of changes in accounting policies, accounting estimates and errors",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfClaimsAndBenefitsPaidExplanatory",
      "label": "Disclosure of claims and benefits paid",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfCollateralExplanatory",
      "label": "Disclosure of collateral",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfCommodityPriceRiskExplanatory",
      "label": "Disclosure of commodity price risk",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfComparativeInformationPreparedUnderPreviousGAAPExplanatory",
      "label": "Disclosure of comparative figures",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfConstructionContractsExplanatory",
      "label": "Disclosure of construction contracts",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfContingentAssetsAndContingentLiabilitiesExplanatory",
      "label": "Disclosure of contingent assets and contingent liabilities",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfCorporateProposalsExplanatory",
      "label": "Disclosure of corporate proposals",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfCostOfSalesExplanatory",
      "label": "Disclosure of cost of sales",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfCreditRiskExplanatory",
      "label": "Disclosure of credit risk",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfAccountingJudgementsAndEstimatesExplanatory",
      "label": "Disclosure of critical accounting estimates and judgements",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfDeferredIncomeExplanatory",
      "label": "Disclosure of deferred income",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfDeferredTaxesExplanatory",
      "label": "Disclosure of deferred tax assets/(liabilities)",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfDepositsFromBanksExplanatory",
      "label": "Disclosure of deposits from banks",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfDepositsPlacedWithLicensedBanksExplanatory",
      "label": "Disclosure of deposits with financial institutions",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfDepreciationAndAmortisationExpenseExplanatory",
      "label": "Disclosure of depreciation and amortisation expense",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfDerivativeFinancialInstrumentsExplanatory",
      "label": "Disclosure of derivative financial assets/liabilities",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfDevelopmentExpenditureExplanatory",
      "label": "Disclosure of development expenditures",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfDiscontinuedOperationsExplanatory",
      "label": "Disclosure of discontinued operations",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfDisposalOfSubsidiariesExplanatory",
      "label": "Disclosure of disposal of subsidiaries",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfDividendsExplanatory",
      "label": "Disclosure of dividends",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfEarningsPerShareExplanatory",
      "label": "Disclosure of earnings (loss) per share",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfEffectOfChangesInForeignExchangeRatesExplanatory",
      "label": "Disclosure of effect of changes in foreign exchange rates",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfEmployeeBenefitsExplanatory",
      "label": "Disclosure of employee benefits expense",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfEmploymentTerminationBenefitsExplanatory",
      "label": "Disclosure of employment termination benefits",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfEntitysReportableSegmentsExplanatory",
      "label": "Disclosure of entity's operating segments",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfEquityPriceRiskExplanatory",
      "label": "Disclosure of equity price risk",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfEventsAfterReportingPeriodExplanatory",
      "label": "Disclosure of events after reporting period",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfFairValueHierarchyExplanatory",
      "label": "Disclosure of fair value information",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfFairValueMeasurementExplanatory",
      "label": "Disclosure of fair value measurement",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfFairValueOfFinancialInstrumentsExplanatory",
      "label": "Disclosure of fair value of financial instruments",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfFeeAndCommissionIncomeExpenseExplanatory",
      "label": "Disclosure of fee and commission income (expense)",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfFeesForNonAuditServicesProvidedByCompanysAuditorAndItsMemberFirmsExplanatory",
      "label": "Disclosure of fees for non-audit services provided by the Company's auditor and its member firms",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfFinanceCostExplanatory",
      "label": "Disclosure of finance costs",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfFinanceIncomeExplanatory",
      "label": "Disclosure of finance income",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfFinancialAssetsAndLiabilitiesThatAreMeasuredAtFairValueExplanatory",
      "label": "Disclosure of financial assets at fair value through other comprehensive income",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfFinancialGuaranteeExplanatory",
      "label": "Disclosure of financial guarantees",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfFinancialInstrumentsMeasuredAtAmortisedCostExplanatory",
      "label": "Disclosure of financial instrument measured at amortised cost",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfFinancialInstrumentsExplanatory",
      "label": "Disclosure of financial instruments",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfFinancialInstrumentsAtFairValueThroughProfitOrLossExplanatory",
      "label": "Disclosure of financial instruments at fair value through profit or loss",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfFinancialInstrumentsHeldForTradingExplanatory",
      "label": "Disclosure of financial instruments held for trading",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfFinancialLiabilitiesMeasuredAtAmortisedCostExplanatory",
      "label": "Disclosure of financial liabilities measured at amortised cost",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfFirstTimeAdoptionExplanatory",
      "label": "Disclosure of first-time adoption",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfForeignCurrencyTranslationReserveExplanatory",
      "label": "Disclosure of foreign currency translation reserve",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfGeneralInformationAboutFinancialStatementsExplanatory",
      "label": "Disclosure of general information about financial statements",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfGoingConcernExplanatory",
      "label": "Disclosure of going concern",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfGrantsAndContributionsExplanatory",
      "label": "Disclosure of grants and contributions",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfGrossProfitExplanatory",
      "label": "Disclosure of gross profit",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfHeldToMaturityInvestmentExplanatory",
      "label": "Disclosure of held to maturity investment",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfHoldingCompaniesExplanatory",
      "label": "Disclosure of holding companies",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfIncomeTaxExplanatory",
      "label": "Disclosure of income tax expense",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfIntangibleAssetsAndGoodwillExplanatory",
      "label": "Disclosure of intangible assets and goodwill",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfInterestInJointOperationsExplanatory",
      "label": "Disclosure of interest in joint operation",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfInterestsInUnconsolidatedStructuredEntitiesExplanatory",
      "label": "Disclosure of interests in unconsolidated structured entities",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfInterestRateRiskExplanatory",
      "label": "Disclosure of interest rate risk",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfInventoriesExplanatory",
      "label": "Disclosure of inventories",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfInvestmentPropertyExplanatory",
      "label": "Disclosure of investment property",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfInvestmentInAssociateExplanatory",
      "label": "Disclosure of investments in associates",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfInvestmentInJointVentureExplanatory",
      "label": "Disclosure of investments in joint ventures",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfInvestmentInSubsidiaryCompaniesExplanatory",
      "label": "Disclosure of investments in subsidiary companies",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfIrremedableConvertibleUnsecuredLoanStocksExplanatory",
      "label": "Disclosure of irredeemable convertible unsecured loan stocks",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfIslamicFinancingFacilitiesExplanatory",
      "label": "Disclosure of islamic financing facilities",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfIssuedCapitalExplanatory",
      "label": "Disclosure of issued capital",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfKeyManagementPersonnelCompensationExplanatory",
      "label": "Disclosure of key management personnel compensation",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfLandHeldForDevelopmentExplanatory",
      "label": "Disclosure of land held for development",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfLeasePrepaymentsExplanatory",
      "label": "Disclosure of lease prepayments",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfLeasesExplanatory",
      "label": "Disclosure of leases",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfLiquidityRiskExplanatory",
      "label": "Disclosure of liquidity risk",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfListOfSubsidiariesJointVenturesAndAssociatesExplanatory",
      "label": "Disclosure of list of subsidiaries, joint ventures and associates",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfLoansAndAdvancesToBanksExplanatory",
      "label": "Disclosure of loans and advances to banks",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfLoansAndReceivablesExplanatory",
      "label": "Disclosure of loans and receivables",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfLongTermPayablesExplanatory",
      "label": "Disclosure of long term payables",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfLongTermReceivablesExplanatory",
      "label": "Disclosure of long term receivables",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfMaturityAnalysisUnderLiquidityRiskExplanatory",
      "label": "Disclosure of maturity analysis under liquidity risk",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfNetAssetValueAttributableToUnitholdersExplanatory",
      "label": "Disclosure of net asset value attributable to unit-holders",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfNetGainsAndLossesArisingFromFinancialInstrumentsExplanatory",
      "label": "Disclosure of net gains and losses arising from financial instruments",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfNoncontrollingInterestsExplanatory",
      "label": "Disclosure of non-controlling interests",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfNoncurrentAssetsHeldForSaleAndDiscontinuedOperationsExplanatory",
      "label": "Disclosure of non-current assets or disposal groups classified as held for sale and discontinued operations",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfNonderivativeFinancialInstrumentsExplanatory",
      "label": "Disclosure of non-derivative financial instruments",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfNonExecutiveDirectorsFeesExplanatory",
      "label": "Disclosure of non-executive director's fees",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfOtherCurrentAssetsExplanatory",
      "label": "Disclosure of other current assets",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfOtherCurrentLiabilitiesExplanatory",
      "label": "Disclosure of other current liabilities",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfOtherFinancialRiskManagementExplanatory",
      "label": "Disclosure of other financial risk management",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfOtherGainsAndLossesExplanatory",
      "label": "Disclosure of other gains and losses",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfOtherGuaranteesExplanatory",
      "label": "Disclosure of other guarantees",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfOtherIncomeExplanatory",
      "label": "Disclosure of other income",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfOtherInvestmentsExplanatory",
      "label": "Disclosure of other investments",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfOtherLongTermEmploymentBenefitsExplanatory",
      "label": "Disclosure of other long term employment benefits",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfOtherMarketRiskExplanatory",
      "label": "Disclosure of other market risk",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfOtherNoncurrentAssetsExplanatory",
      "label": "Disclosure of other non-current assets",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfOtherNoncurrentLiabilitiesExplanatory",
      "label": "Disclosure of other non-current liabilities",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfOtherNotesToAccountsExplanatory",
      "label": "Disclosure of other notes to accounts",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfOtherOperatingExpenseExplanatory",
      "label": "Disclosure of other operating expenses",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfOtherOperatingIncomeExplanatory",
      "label": "Disclosure of other operating income",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfOtherProvisionsExplanatory",
      "label": "Disclosure of other provisions",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfOtherReservesExplanatory",
      "label": "Disclosure of other reserves",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfPerpetualSukukExplanatory",
      "label": "Disclosure of perpetual sukuk",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfPostEmploymentBenefitObligationsExplanatory",
      "label": "Disclosure of post employment benefit obligation",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfPriceRiskExplanatory",
      "label": "Disclosure of price risk",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfPriorPeriodAdjustmentsExplanatory",
      "label": "Disclosure of prior year adjustments",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfProfitAfterTaxExplanatory",
      "label": "Disclosure of profit after tax",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfProfitBeforeTaxExplanatory",
      "label": "Disclosure of profit before tax",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfProgressBillingAndOthersExplanatory",
      "label": "Disclosure of progress billings and others",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfPropertyDevelopmentCostsExplanatory",
      "label": "Disclosure of property development costs",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfPropertyPlantAndEquipmentExplanatory",
      "label": "Disclosure of property, plant and equipment",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfResearchAndDevelopmentExpenseExplanatory",
      "label": "Disclosure of research and development expense",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfRevenueFromContractsWithCustomersExplanatory",
      "label": "Disclosure of revenue from contract customers",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfServiceConcessionArrangementsExplanatory",
      "label": "Disclosure of service concession arrangements",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfShareCapitalReservesAndOtherEquityInterestExplanatory",
      "label": "Disclosure of share capital",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfSharebasedPaymentArrangementsExplanatory",
      "label": "Disclosure of share-based payment arrangements",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfShortTermInvestmentsExplanatory",
      "label": "Disclosure of short term investments",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfSignificantEventsDuringFinancialYearExplanatory",
      "label": "Disclosure of significant events during the financial year",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfStatementOfComplianceExplanatory",
      "label": "Disclosure of statement of compliance",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfSupplementaryFinancialInformationOnBreakdownOfRealisedAndUnrealisedProfitOrLossesExplanatory",
      "label": "Disclosure of supplementary financial information on the breakdown of realised and unrealised profits or losses",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfTaxReceivablesAndPayablesExplanatory",
      "label": "Disclosure of tax receivables and payables",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfTaxSupplementaryInformationExplanatory",
      "label": "Disclosure of tax supplementary information",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfNewOrRevisedFinancialReportingStandardsNotYetEffectiveExplanatory",
      "label": "Disclosure of the new or revised financial reporting standards not yet effective",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfTradeAndOtherInventoriesExplanatory",
      "label": "Disclosure of trade and other inventories",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfTradeAndOtherPayablesExplanatory",
      "label": "Disclosure of trade and other payables",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfTradeAndOtherReceivablesExplanatory",
      "label": "Disclosure of trade and other receivables",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfTreasurySharesExplanatory",
      "label": "Disclosure of treasury shares",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    }
  ]
}
